<template>
  

  <CModal
  v-model="show" 
  title="Add Asset"
  :cancel-label="cancelLable"
  :confirm-label="confirmLabel"
  @hide='hide'
  @submit="submit"
  :tag="false"
  :progressing="loading"
  :size="'lg'"
   centered
    >   
    <b-container class="ml-4 mb-4">
      <b-row class="d-flex flex-row justify-content-start mb-2">
        <b-button class="asset-type-btn" v-if="assetType === 'Menu Display'" variant="warning">Menu Display</b-button>
        <b-button class="asset-type-btn" @click="changeAssetType('Menu Display')" variant="outline-primary" v-else>Menu Display</b-button>
      </b-row>
      <b-row class="d-flex flex-row justify-content-start mb-2" :style="{'gap':'0.4rem'}">
        
        <b-button class="asset-type-btn" v-if="assetType === 'Self-Ordering Kiosk'" variant="warning">Self-Ordering Kiosk</b-button>
        <b-button class="asset-type-btn" @click="changeAssetType('Self-Ordering Kiosk')" variant="outline-primary" v-else>Self-Ordering Kiosk</b-button>

        <b-button class="asset-type-btn" v-if="assetType === 'Thermal Printer'" variant="warning">Thermal Printer</b-button>
        <b-button class="asset-type-btn" @click="changeAssetType('Thermal Printer')" variant="outline-primary" v-else>Thermal Printer</b-button>

        <b-button class="asset-type-btn" v-if="assetType === 'Card Reader'" variant="warning">Card Reader</b-button>
        <b-button class="asset-type-btn" @click="changeAssetType('Card Reader')" variant="outline-primary" v-else>Card Reader</b-button>

      </b-row>
      <b-row class="d-flex flex-row justify-content-start ">
        <b-button class="asset-type-btn" v-if="assetType === 'Kitchen Display (KDS)'" variant="warning">Kitchen Display (KDS)</b-button>
        <b-button class="asset-type-btn" @click="changeAssetType('Kitchen Display (KDS)')" variant="outline-primary" v-else >Kitchen Display (KDS)</b-button>

      </b-row>
      <b-row class="d-flex flex-row justify-content-start ">
        <b-button class="asset-type-btn" v-if="assetType === 'POS Terminal Display'" variant="warning">POS Terminal Display</b-button>
        <b-button class="asset-type-btn" @click="changeAssetType('POS Terminal Display')" variant="outline-primary" v-else>POS Terminal Display</b-button>
      </b-row>
    </b-container>
    <b-row v-if="err != ''" class="d-flex flex-row justify-content-center" ><p :style="{color: 'red', 'font-size': '1rem'}" class="text-center">{{ err }}</p> </b-row>

    <b-container v-if="assetType === 'Menu Display' || assetType === 'Self-Ordering Kiosk' || assetType === 'POS Terminal Display' || assetType === 'Kitchen Display (KDS)' ">
      <b-input-group  prepend="Asset Name">
        <b-form-input class="" type="text" name="Asset Name" placeholder="Required" v-validate="'required'" v-model="assetName"/>
      </b-input-group>
    </b-container>

    <b-container v-if="assetType=== 'Thermal Printer'">

        <b-input-group prepend="Asset Name" class="mb-3">
          <b-form-input class="" type="text" name="Asset Name" placeholder="Required" v-validate="'required'" v-model="assetName"/>
        </b-input-group>

        <b-row class="d-flex flex-row justify-content-start ml-2" :style="{gap:'0.4rem'}">
          <p class="pt-2">Used for:</p>
          
          <b-button class="printer-type-btn" variant="warning" v-if="printerType === 'Order Ticket'">Order Ticket</b-button>
          <b-button class="printer-type-btn" @click="changePrinterType('Order Ticket')" variant="outline-primary" v-else>Order Ticket</b-button>

          <b-button class="printer-type-btn" variant="warning" v-if="printerType === 'Customer Receipt'">Customer Receipt</b-button>
          <b-button class="printer-type-btn" @click="changePrinterType('Customer Receipt')" variant="outline-primary" v-else>Customer Receipt</b-button>

    
        </b-row>
        <b-row class="mt-3">
          <b-col cols="12" md="6">
            <b-input-group prepend="IP Address" class="mb-3">
              <b-form-input class="" type="text" name="IP Address" placeholder="Required" v-validate="'required'" v-model="IP"/>
            </b-input-group>
          </b-col>
          <b-col cols="12" md="6">
            <b-input-group prepend="Port Number" class="mb-3">
              <b-form-input class="" type="number" name="Port Number" v-validate="'required'" v-model="portNumber"/>
            </b-input-group>
          </b-col>
        </b-row>

    </b-container>
    <b-container v-if="assetType === 'Card Reader'">
      <b-col>
        <p>Swipe from left to right on the reader screen to see Setting button and enter admin PIN 07139 to access Admin Options menu. Select "Generate pairing code" to get a new Registration Code and enter it below.
          Note: MENUPOLY only supports Strip card reader at this point.</p>
      </b-col>
        <b-col>
            <b-input-group prepend="Asset Name" class="mb-3">
              <b-form-input class="" type="text" name="Asset Name" placeholder="Required"  v-model="assetName"/>
            </b-input-group>
          </b-col>
          <b-col>
            <b-input-group prepend="Registration Code" class="mb-3">
              <b-form-input class="" type="text" name="Registration Code" placeholder="Required" v-validate="'required'" v-model="registrationCode"/>
            </b-input-group>
          </b-col>
    </b-container>
      
    
    
    
    
    
  </CModal>
  
</template>

<script>
import CModal from "../shared/Cmodal";
 
export default {
    name:"addAssets",
    props:{
        show:{type:Boolean}
    },
    components:{
        CModal
    },
    data(){
      return{
        assetType:"Menu Display",
        assetName:"",
        loading:false,
        printerType:"",
        portNumber:9100,
        registrationCode:"",
        IP:'',
        err:'',
        cancelLable:"Cancel",
        confirmLabel: "Save"
      }
    },
    methods:{
      
      changeAssetType(assetType){
        this.assetName = ""
        this.printerType = ""
        this.portNumber = 9100
        this.IP = ""
        this.err = ""
        this.registrationCode = ""
        if(assetType === "Card Reader")
          this.confirmLabel = "Register Card Reader"
        else  
          this.confirmLabel = "Save"
        this.assetType = assetType
      },
      changePrinterType(printerType){
        this.err = ""
        this.printerType = printerType
      },
      hide(){
        this.registrationCode = ""
        this.assetType ="Menu Display"
        this.assetName = ""
        this.printerType = ""
        this.portNumber = 9100
        this.IP = ""
        this.err = ""
        this.$emit('hideWindow')
      },
       isIpValid(IP) {
  
        const ipv4Regex = /^(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}$/;

        return ipv4Regex.test(IP);
      },
      submit(){
      let model = 
        {
          RestaurantID: localStorage.getItem('selectedRestaurant'),
          AssetCategory: "AssetCategory",
          
          Printer: {
              PrinterName: "PrinterName",
              MAC: "MAC",
              IPAddress: "IPAddress",
              PrintTaskID: 1,
              Port: 123
          },
          Pos: {
          POSName: "POSName",
          POSCode: "POSCode"
          },
          KDS:{
              KDSName:"KDSName"
            }
            
        }
        

        
        if(this.assetType === "Menu Display" || this.assetType === "Self-Ordering Kiosk" || this.assetType === "POS Terminal Display" || this.assetType === 'Kitchen Display (KDS)'){
          if(this.assetName === "")
            return this.err = "Asset Name is required"
          
          if( this.assetType === 'Kitchen Display (KDS)'){
            model.KDS.KDSName = this.assetName
          }

          model.AssetCategory = this.assetType
          model.AssetName = this.assetName
          
          this.loading = true
          
          this.$api.asset.Create(model).then(res=>{
            this.loading = false
              this.hide()
            
          })
        }
        if(this.assetType === "Card Reader"){
          if(this.assetName === "")
            return this.err = "Asset Name is required"
          if(this.registrationCode === "")
            return this.err = "Registration Code is required"
          
          model.Pos.POSName= this.assetName,
          model.Pos.POSCode= this.registrationCode
          model.AssetCategory = this.assetType
          model.AssetName = this.assetName
          
          
          this.loading = true
            
          this.$api.asset.Create(model).then(res => {
              this.loading = false
                  if(res.message != 'asset successfully created'){
                    return this.err = "Registration Code is Invalid!"
                  }
                  this.hide()
              
          }).catch(() => {
              this.err = "Something went wrong!"
              this.loading = false
          })
        }
        if(this.assetType === "Thermal Printer"){
          if(this.assetName === "")
            return this.err = "Asset Name is required"
          
          if(!this.isIpValid(this.IP))
            return this.err = "Please Enter a valid IP address"

          if(this.IP === "")
            return this.err = "IP address is required"
          
          if(this.printerType === "")
            return this.err = "Please select what the printer is used for."


          model.AssetCategory = this.assetType
          model.AssetType = "Printer"
          model.AssetName = this.assetName

          model.IPAddress = this.IP
          model.Printer.IPAddress = this.IP

          model.Printer.Port = this.portNumber
          model.Printer.PrinterName = this.assetName

          if(this.printerType === "Order Ticket")
            model.Printer.PrintTaskID = 1
          else
            model.Printer.PrintTaskID = 2
          
          
            this.$api.asset.Create(model).then(res => {
            this.loading = false
            
            this.hide()
            
            
          }).catch(() => {
              this.err = "IPAddress and name fields must be unique."
              this.loading = false
          })
            
        }



        

        
      }
    }
}
</script>

<style lang="css" scoped>
  input::placeholder{
    opacity: 0.5 !important;
  }
  .asset-type-btn{
    border-radius: 0 !important;
    border: 1px solid gray !important;
    height: 2rem !important;
    width: 12rem !important;
    color:  black !important;
  }
  .printer-type-btn{
    border-radius: 0 !important;
    border: 1px solid gray !important;
    height: 2rem !important;
    width: 10rem !important;
    color:  black !important;
  }
  

</style>